import classNames from 'classnames';
import { Heading } from 'components/1-atoms/Heading';
import { Picture2 } from 'components/1-atoms/Media/Picture2/Picture2';
import CalendarIcon from 'icons/icon-calendar-small.svg';
import MapPinIcon from 'icons/icon-map-pin-small.svg';
import { customizeElement } from 'utilities/customizeElement';
import { formatDate } from 'utilities/date';
import styles from './CatalogListItem.module.scss';

export interface CatalogListItemProps {
	id?: string;
	className?: string;
	heading: string;
	headingLevel?: 'h2' | 'h3';
	headingStyle?: 'md' | 'xs';
	link: React.ReactElement;
	teaser?: string;
	date?: string;
	additionalInfo?: {
		date: string;
		location: string;
	};
	image?: UI.Image;
}

export const CatalogListItem: React.FC<CatalogListItemProps> = ({ className, heading, headingLevel = 'h2', headingStyle = 'md', link, teaser, date, additionalInfo, image }) => {
	return (
		<li className={classNames(styles.CatalogListItem, className)}>
			{customizeElement({
				element: link,
				style: styles.CatalogListItem_link,
				children: (
					<>
						{image && (
							<div className={styles.CatalogListItem_media}>
								{/* Size compensates for height */}
								<Picture2 url={image.url} aspectRatio={1/1} altText={image.altText} focalPoint={{ left: 0, top: 0 }} isFullHeight sizes="480px" />
							</div>
						)}
						<div>
							{date && <p className={styles.CatalogListItem_date}>{formatDate(date.split('T')[0], 'dd-mm-yyyy')}</p>}
							<Heading className={styles.CatalogListItem_heading} headingLevel={headingLevel} style={headingStyle}>
								{heading}
							</Heading>
							{additionalInfo && (
								<div className={styles.CatalogListItem_additionalInfo}>
									<p className={styles.CatalogListItem_additionalInfo_text}>
										<CalendarIcon className={styles.CatalogListItem_icons} />
										{formatDate(additionalInfo.date.split('T')[0], 'dd-mm-yyyy')}
									</p>
									<p className={styles.CatalogListItem_additionalInfo_text}>
										<MapPinIcon className={styles.CatalogListItem_icons} />
										{additionalInfo.location}
									</p>
								</div>
							)}
							<p>{teaser}</p>
						</div>
					</>
				),
			})}
		</li>
	);
};
